import React, { useEffect, useState } from "react";
import Loader from "../Loader";
import { Box } from "@mui/material";
import LoadMap from "./Loadmap";
import { loadGoogleMaps } from "./loadGoogleMaps";

const Map = (props) => {
  const { onSubmit, fences = [] } = props;
  const [googeMap, setGoogleMap] = useState();
  useEffect(() => {
    let cancelled = false;
    // shared singleton loader — avoids double-loading the SDK (which corrupts its
    // internals: "undefined is not an object (evaluating 'p.kK')").
    loadGoogleMaps().then((g) => { if (!cancelled) setGoogleMap(g); }).catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return (
    <Box width={"100%"}>
      {googeMap ? (
        <LoadMap googeMap={googeMap} onSubmit={onSubmit} fences={fences} />
      ) : (
        <Loader />
      )}
    </Box>
  );
};

export default Map;
